import React from 'react'
import TestimonialSlider from '../../Common/TestimonialSlider/TestimonialSlider'
import EmergenciBanner from './EmergenciBanner'
import EmergenciServices from './EmergenciServices'
import ProjectStats from '../../Common/ProjectStats/ProjectStats'

function Emergenci() {
    return (
        <div>
            <EmergenciBanner/>
            <EmergenciServices/>
            <ProjectStats/>
            <TestimonialSlider/>
        </div>
    )
}

export default Emergenci
